const ChevronUp = ({ strokeColor = "black", className = "" }) => {
  return (
    <div className={`relative -top-[1.5px] ${className}`}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 15L16 9L10 15"
          className={`stroke-black opacity-50 group-hover:stroke-[${strokeColor}]`}
          stroke="black"
          stroke-width="2"
          stroke-linecap="square"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default ChevronUp;
